import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss']
})
export class SelectComponent {

  @Input() textCentered: boolean = true;
  @Input() selectedItem: any;
  @Input() disabled: boolean = false;
  @Input() largeSize: boolean = false;
  @Input() options: Array<any> | any;
  @Input() isDateRange: boolean = false;
  @Output() changeSelect: EventEmitter<string> = new EventEmitter<string>();

  /**
   * Native `<select>` matches options by string value, so an absent filter (`undefined`/`null`)
   * matched no option and rendered blank instead of the leading "All …" entry. Coerce to the
   * empty string, which is what those entries use as their value.
   */
  get selection(): string {
    return this.selectedItem === null || this.selectedItem === undefined
      ? ''
      : this.selectedItem.toString();
  }

  onModelChange(value: any) {
    this.changeSelect.emit(value != null ? value.toString() : '');
  }
}
